import VcomProvider from './VcomProvider';
import FilterService from './beamer/FilterService';

const productId = 'cPBbWfhv49238';

function createScript() {
  const element = document.createElement('script');
  element.type = 'text/javascript';
  element.defer = true;
  element.src = 'https://app.getbeamer.com/js/beamer-embed.js';

  return element;
}

function getLanguageCode() {
  const languageCode = VcomProvider.LanguageSwitch.getCurrentLanguage().toUpperCase();

  if (languageCode === 'US') {
    return 'EN';
  }

  return languageCode;
}

export default async function installBeamer() {
  const filters = [
    VcomProvider.isDevelopmentMode ? 'beta' : 'vcom',
    await FilterService.shouldShowLegacyAlarmMessage() ? 'legacyAlarmShutdown' : null,
  ].filter((val) => val !== null);

  window.beamer_config = {
    product_id: productId,
    language: getLanguageCode(),
    filter: filters.join(';'),
    user_id: VcomProvider.userId,
  };

  document.body.appendChild(createScript());
}
